import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=0c7efe12&"
import script from "@/scripts/register.js?vue&type=script&lang=js&"
export * from "@/scripts/register.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports